import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  // 表格数据
  table: [],
  // 分页参数
  pagination: {
    current_page: 1,
    per_page: 20,
    total: 0,
  },
}

// getters
const getters = {
  // demoTable: state => state.table
}

// actions
const actions = {
  getResumeTable ({commit, state}, params) {
    let promised = request.alert('getResumeTable', params)
    return promised
  },
  getResumeForm ({commit, state}, id) {
    let promised = request.alert('getResumeForm', id)
    return promised
  },
  exportResume ({commit, state}, params) {
    let promised = request.alert('exportResume', params)
    return promised
  },
  exportResumes ({commit, state}, params) {
    let promised = request.alert('exportResumes', params)
    return promised
  },
  appliedResume ({commit, state}, params) {
    let promised = request.alert('appliedResume', params)
    return promised
  },
  sendResumes ({commit, state}, params) {
    let promised = request.alert('sendResumes', params)
    return promised
  },
  downloadResume ({commit, state}, path) {
    let promised = request.alert('downloadResume', path)
    return promised
  },
  getResumeOptions ({commit, state}) {
    let promised = request.alert('getResumeOptions')
    return promised
  },
  getResumeAllTable ({commit, state}, params) {
    let promised = request.alert('getResumeAllTable', params)
    return promised
  },
  getResumeCity ({commit, state}, params) {
    let promised = request.alert('getResumeCity', params)
    return promised
  },
  editResume ({commit, state}, params) {
    let promised = request.alert('editResume', params)
    return promised
  },
  uploadResumeImg ({commit, state}, params) {
    let promised = request.alert('uploadResumeImg', params)
    return promised
  },
  queryCity ({commit, state}, params) {
    let promised = request.alert('queryCity', params)
    return promised
  },

}

// mutations
const mutations = {
  [types.SET_USER_TABLE] (state, table) {
    state.table = table
  },
  [types.SET_USER_PAGINATION] (state, pagination) {
    state.pagination.current_page = Number(pagination.current_page)
    state.pagination.per_page = Number(pagination.per_page)
    state.pagination.total = Number(pagination.total)
  },
}

export const resume = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/resume/resume.store.js